export const formatDate = (value: string): string => {
  const date = new Date(value);
  let format = 'DD-MM-YYYY HH:mm:ss';

  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  const hours = String(date.getHours()).padStart(2, '0');
  const minutes = String(date.getMinutes()).padStart(2, '0');
  const seconds = String(date.getSeconds()).padStart(2, '0');

  format = format.replace('YYYY', String(year));
  format = format.replace('MM', month);
  format = format.replace('DD', day);
  format = format.replace('HH', hours);
  format = format.replace('mm', minutes);
  format = format.replace('ss', seconds);

  return format;
};

export const formatDateNoSeconds = (value: string): string => {
  const date = new Date(value);
  let format = 'DD/MM/YYYY HH:mm';

  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  const hours = String(date.getHours()).padStart(2, '0');
  const minutes = String(date.getMinutes()).padStart(2, '0');

  format = format.replace('YYYY', String(year));
  format = format.replace('MM', month);
  format = format.replace('DD', day);
  format = format.replace('HH', hours);
  format = format.replace('mm', minutes);

  return format;
};

export const formatDateNoTime = (value: string): string => {
  const date = new Date(value);
  let format = 'DD/MM/YYYY ';

  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');

  format = format.replace('YYYY', String(year));
  format = format.replace('MM', month);
  format = format.replace('DD', day);

  return format;
};

export const minuteBetween2Date = (beforeDate: Date, afterDate: Date): number => {
  const diffInMs = afterDate.getTime() - beforeDate.getTime();
  return Math.floor(diffInMs / (1000 * 60));
};

export const compareCommenceTime = (
  a: { id: string; startDate: string; isPinned: boolean },
  b: { id: string; startDate: string; isPinned: boolean },
): -1 | 1 | 0 => {
  if (a.isPinned !== b.isPinned) {
    return a.isPinned ? -1 : 1;
  }

  if (a.startDate < b.startDate) return -1;
  else if (a.startDate > b.startDate) return 1;
  else if (a.id < b.id) return -1;
  else if (a.id > b.id) return 1;
  return 0;
};
